import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;

@Component({
  selector: 'sod-forwards-h',
  templateUrl: './sod-forwards-h.component.html',
  styleUrls: ['./sod-forwards-h.component.css'],
})

export class SODForwardsHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Start of Day Forward Position Event Log");

    /*<![CDATA[*/
		var mainNav = "history-nav";
		var sideNav = "side-nav-history-forward-positions";

		$(document).ready(function() {
			// prepare the data
			var data = [ {
				"timestamp" : "5/5/2015 06:08:46.689",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account C",
				"ccy" : "USD",
				"quantity" : "12K",
				"valueDate" : "5/31/2015"
			}, {
				"timestamp" : "5/5/2015 06:08:47.577",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account C",
				"ccy" : "CAD",
				"quantity" : "20K",
				"valueDate" : "5/31/2015"
			}, {
				"timestamp" : "5/5/2015 06:08:47.689",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account D",
				"ccy" : "GBP",
				"quantity" : "-10K",
				"valueDate" : "5/31/2015"
			}, {
				"timestamp" : "5/5/2015 06:09:02.500",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account D",
				"ccy" : "CAD",
				"quantity" : "17K",
				"valueDate" : "5/31/2015"
			}, {
				"timestamp" : "5/5/2015 06:09:42.564",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account E",
				"ccy" : "GBP",
				"quantity" : "35K",
				"valueDate" : "5/31/2015"
			}, {
				"timestamp" : "5/5/2015 06:09:47.577",
				"user" : "System",
				"ipAddress" : "12.56.8.32",
				"accountCode" : "Account E",
				"ccy" : "CAD",
				"quantity" : "10K",
				"valueDate" : "5/31/2015"
			} ];

			// initialize jqxGrid
			var source = {
				localdata : data,
				datafields : [ {
					name : 'timestamp',
					type : 'string'
				}, {
					name : 'user',
					type : 'string'
				}, {
					name : 'ipAddress',
					type : 'string'
				}, {
					name : 'accountCode',
					type : 'string'
				}, {
					name : 'ccy',
					type : 'string'
				}, {
					name : 'quantity',
					type : 'string'
				}, {
					name : 'valueDate',
					type : 'string'
				} ]
			};
			var settings = defaultGridViewSettings("#jqxgrid", source);
			settings.columns = [ {
				text : 'Timestamp',
				columntype : 'textbox',
				datafield : 'timestamp',
				width : '160'
			}, {
				text : 'User',
				columntype : 'textbox',
				datafield : 'user',
				width : '100'
			}, {
				text : 'IP Address',
				columntype : 'textbox',
				datafield : 'ipAddress',
				width : '80'
			}, {
				text : 'Account',
				columntype : 'textbox',
				datafield : 'accountCode',
				width : '120'
			}, {
				text : 'Ccy',
				columntype : 'textbox',
				datafield : 'ccy',
				width : '100'
			}, {
				text : 'Quantity',
				columntype : 'textbox',
				datafield : 'quantity',
				width : '100'
			}, {
				text : 'Value Date',
				columntype : 'textbox',
				datafield : 'valueDate',
				width : '100'
			} ];
			$("#jqxgrid").jqxGrid(settings);
		});
	/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sod-forwards-h/sod-forwards-h.component.ts